// Локализация payment_method для админки.
// После миграции 20260509_0007 в БД хранятся только канонические значения:
//   Карта / QR / Наличные / Р/с / ЮКасса / Счёт {бренд} / Не требуется.
// Хелпер срезает скобки-хвост (защита от ручных правок) и пропускает значение как есть.
// Маппинги для legacy-значений убраны — они больше не встречаются после миграции.
export function paymentMethodLabel(raw) {
  if (!raw) return null;
  const v = String(raw).replace(/\s*\(.*\)\s*$/, '').trim();
  // Заказы Flowwow до 30.09.2026 записаны как «flowwow» — бренд пишется с большой буквы
  if (v.toLowerCase() === 'flowwow') return 'Flowwow';
  return v || null;
}
